import './reset-password.css';
import Header from '../components/header';
import Form from 'react-bootstrap/Form';
import FaceIcon from '../images/face-icon.png';
import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Loader from '../components/loader'; // Import the Loader component
import CustomToaster from '../components/custom-toaster'; // Import the CustomToaster component
import { postData } from '../utils/apis/api';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Fetch the email from the state if available
  const emailId = location.state?.email || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const [showToast, setShowToast] = useState(false); // Toast visibility state
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState(''); // Toast type: 'success' or 'error'

  const handleNewPassword = (e) => {
    setNewPassword(e.target.value);
    setError('');
  };

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
    setError('');
  };

  const handleButtonClick = async () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
  
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }
  
    setIsLoading(true); // Show Loader
    setShowToast(false); // Hide previous toast
    setToastMessage(''); // Clear previous message
  
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
  
    const data = { token: token, new_password: confirmPassword };
  
    try {
      const response = await postData('/reset-password', data, headers);
  
      if (response.detail === 'Password reset successful') {
        setToastMessage('Password has been successfully reset!');
        setToastVariant('success');
        setShowToast(true);
  
        // Redirect to login page after 2 seconds
        setTimeout(() => {
          if(sessionStorage.getItem('agentName')){
            navigate('/?agentName='+sessionStorage.getItem('agentName'));
          }
          else{
            navigate('/');
          }
        }, 2000);
      } else {
        throw new Error(response.message || 'Failed to reset password');
      }
    } catch (error) {
      // Extract error message and ensure it's a string
      const errorMessage =
        error.response?.data?.message || // API-provided error message
        error.response?.data?.detail || // API-provided detailed error
        error.message || // Error message from the error object
        'Failed to reset password. Please try again.'; // Fallback message
  
      setToastMessage(errorMessage); // Display error message
      setToastVariant('error'); // Error variant
      setShowToast(true);
    } finally {
      setIsLoading(false); // Hide Loader
    }
  };  

  return (
    <>
      <Header />
      <div className="LoginMain">
        <div className="LoginContainer">
          <img src={FaceIcon} alt="icon" width="119" height="119" />
          <h2 className="my-4 LoginText">Reset your password</h2>
          <Form.Control
            value={newPassword}
            onChange={handleNewPassword}
            className="my-3"
            type="password"
            placeholder="Enter new password*"
            required
          />
          <Form.Control
            value={confirmPassword}
            onChange={handleConfirmPassword}
            className="my-3"
            type="password"
            placeholder="Re-enter password*"
            required
          />
          {error && <p className="text-danger">{error}</p>}{' '}
          {/* Display error message */}
          <button
            onClick={handleButtonClick}
            disabled={!newPassword || !confirmPassword}
            className="ContinueButton col-12"
          >
            {isLoading ? 'Resetting...' : 'Reset Password'}
          </button>
        </div>
      </div>

      {/* Loader */}
      {isLoading && <Loader />}

      {/* Custom Toaster */}
      {toastMessage && (
        <CustomToaster
          show={showToast}
          onClose={() => setShowToast(false)}
          message={toastMessage}
          type={toastVariant}
        />
      )}
    </>
  );
};

export default ResetPassword;
